import { makeStyles } from '@material-ui/core/styles';
import getCommonStyles from './_common';

const useTestimonial = makeStyles((theme) => ({
  ...getCommonStyles(theme),
  root: {
    ...getCommonStyles(theme).sectionContainer,
    background: 'transparent',
    backgroundPosition: 'center',
    position: 'relative',
    padding: theme.spacing(12, 0, 12),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(8, 0, 8),
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      background:
        'radial-gradient(circle at 50% 50%, rgba(0, 212, 170, 0.08) 0%, transparent 55%)',
      pointerEvents: 'none',
    },
  },
  sectionTitle: {
    ...getCommonStyles(theme).sectionTitle,
    fontFamily: '"vester-medium", "Montserrat", "Inter", sans-serif',
    fontWeight: 800,
    letterSpacing: '-0.02em',
    background: 'linear-gradient(135deg, #ffffff 0%, #cdfaf1 45%, #6fe9d6 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  sectionDescription: {
    ...getCommonStyles(theme).sectionDescription,
    color: '#b5c3d3',
  },
}));

export default useTestimonial;
